export var isPreviewableType = function (type) {
    return ['audio', 'video', 'image'].indexOf(type) > -1;
};
//# sourceMappingURL=media.js.map